export const getImageDimensions = (url: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve({ width: img.width, height: img.height })
    }

    img.onerror = reject
    img.src = url
  })
}

// Reads the intrinsic pixel dimensions of a video without playing it,
// mirroring getImageDimensions for images.
export const getVideoDimensions = (url: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.onloadedmetadata = () => {
      resolve({ width: video.videoWidth, height: video.videoHeight })
    }

    video.onerror = reject
    video.src = url
  })
}
